import { environment } from './../../../../environments/environment';
import { CarSequenceMaintenanceSaveRequest } from '../pages/car-sequence-maintenance/interfaces/car-sequence-maintenance-save-request';
import { CarSequenceMaintenanceGetResponse } from '../pages/car-sequence-maintenance/interfaces/car-sequence-maintenance-get-response';
import { CarSequenceMaintenanceGetRequest } from '../pages/car-sequence-maintenance/interfaces/car-sequence-maintenance-get-request';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CarSequenceMaintenanceService {

  private baseUrl: string = `${environment.logisticsApiUrl}/car/carSequenceMaintenance`
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient
  ) { }

  getCarSequences(request: CarSequenceMaintenanceGetRequest): Observable<CarSequenceMaintenanceGetResponse> {
    return this.http.post<CarSequenceMaintenanceGetResponse>(this.baseUrl, request, this.httpOptions);
  }

  saveCarSequencesChanges(request: CarSequenceMaintenanceSaveRequest): Observable<CarSequenceMaintenanceSaveRequest> {
    return this.http.put<CarSequenceMaintenanceSaveRequest>(this.baseUrl, request, this.httpOptions);
  }
}
